import { atom, useAtom } from 'jotai';

export const selectedTabAtom = atom('PromtEmbeddings');

export function useSelectedTabAtom() {
  return useAtom(selectedTabAtom);
}


/* NEW
import { atom, useAtom } from 'jotai';
import tabConfig from '../../config/tabConfig';

const firstTab = tabConfig.tabs.find(tab => tab)?.intent || '';
export const selectedTabAtom = atom(firstTab);

export function useSelectedTabAtom() {
  return useAtom(selectedTabAtom);
}

*/